import apiService from './api';
class NotificacoesService {
    async listar() {
        try {
            const response = await apiService.get('/notificacoes', {
                validateStatus: (status) => status < 500 // Não lançar erro para 404
            });
            if (response.status === 404) {
                return this.getMockNotificacoes();
            }
            return response.data || [];
        }
        catch (error) {
            // Se houver erro, retornar notificações mock
            return this.getMockNotificacoes();
        }
    }
    async marcarComoLida(id) {
        try {
            await apiService.put(`/notificacoes/${id}/lida`);
        }
        catch (error) {
            console.log('Marcar como lida:', id);
        }
    }
    async marcarTodasComoLidas() {
        try {
            await apiService.put('/notificacoes/marcar-todas-lidas');
        }
        catch (error) {
            console.log('Marcar todas como lidas');
        }
    }
    async contarNaoLidas() {
        try {
            const response = await apiService.get('/notificacoes/nao-lidas/count', {
                validateStatus: (status) => status < 500
            });
            if (response.status === 404) {
                const notificacoes = await this.listar();
                return notificacoes.filter(n => !n.lida).length;
            }
            return response.data?.count || response.data || 0;
        }
        catch (error) {
            // Retornar contagem das notificações mock não lidas
            const notificacoes = await this.listar();
            return notificacoes.filter(n => !n.lida).length;
        }
    }
    // Notificações mock para demonstração
    getMockNotificacoes() {
        return [
            {
                id: '1',
                tipo: 'aviso',
                titulo: 'Estoque Baixo',
                mensagem: '5 produtos estão com estoque abaixo do mínimo',
                lida: false,
                data: new Date().toISOString(),
                link: '/estoque'
            },
            {
                id: '2',
                tipo: 'info',
                titulo: 'Nova Ordem de Serviço',
                mensagem: 'OS #1234 foi criada e está aguardando diagnóstico',
                lida: false,
                data: new Date(Date.now() - 3600000).toISOString(),
                link: '/ordens-servico'
            },
            {
                id: '3',
                tipo: 'sucesso',
                titulo: 'Venda Concluída',
                mensagem: 'Venda #5678 foi finalizada com sucesso',
                lida: false,
                data: new Date(Date.now() - 7200000).toISOString(),
                link: '/vendas'
            },
            {
                id: '4',
                tipo: 'info',
                titulo: 'Novo Cliente',
                mensagem: 'Cliente João Silva foi cadastrado',
                lida: true,
                data: new Date(Date.now() - 86400000).toISOString(),
                link: '/clientes'
            },
            {
                id: '5',
                tipo: 'erro',
                titulo: 'Atenção Requerida',
                mensagem: 'OS #9876 está há 3 dias aguardando aprovação',
                lida: true,
                data: new Date(Date.now() - 172800000).toISOString(),
                link: '/ordens-servico'
            }
        ];
    }
}
export default new NotificacoesService();
